// extracted by mini-css-extract-plugin
export default {"wrapper":"rlC_5","highlight":"XGl21","border":"Nh6qf","rounded":"Mzj3R","round":"jdUH2","pulse":"iOGEr","pulseRound":"mR7un","pulseRounded":"ZWrmB"};